import { API_PORTAL_URL } from "./config";

/**
 * Inserts a booking reference log for analytics tracking.
 * @param RoomID The ID of the room (0 if not specific to a room).
 * @param URL The redirect BookingURL or current page location URL if booking URL is unavailable.
 */
export async function insertBookingReference(RoomID: number, URL: string) {
  let geoData = {};
  try {
    const geoRes = await fetch("https://ipapi.co/json/");
    if (geoRes.ok) {
      const data = await geoRes.json();
      geoData = {
        City: data.city || "",
        State: data.region || "",
        Country: data.country_name || "",
        IP: data.ip || "",
        Pincode: data.postal || "",
        Latitude: data.latitude !== undefined ? data.latitude : null,
        Longitude: data.longitude !== undefined ? data.longitude : null,
      };
    }
  } catch (err) {
    console.error("Error fetching geo details from ipapi:", err);
  }

  try {
    const res = await fetch(
      `${API_PORTAL_URL}/Website/InsertBookingReference`,
      {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ RoomID, URL, ...geoData }),
        cache: "no-store",
      },
    );
    const json = await res.json();
    return json;
  } catch (error) {
    console.error("Error inserting booking reference:", error);
    return null;
  }
}
